import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { subHeaderdata } from '../assets/HeaderData';
import Pagination from '../common/Pagination';
import CardDetails from '../components/CardDetails';
import { getAllMovies } from '../store/actions/todosAction';

const AllMovieList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(12);
  const { type } = useParams();
  const movie = useSelector((state) => state?.movie?.movieList);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllMovies(type ? type : 'popular'));
  }, [type]);
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPost = movie?.slice(firstPostIndex, lastPostIndex);

  return (
    <div>
      <div className='flex items-center justify-center gap-2 xl:gap-5 bg-colorOne py-5   '>
        {subHeaderdata.map((subheader, i) => (
          <div className=''>
            <Link
              key={i}
              to={subheader.to}
              className='customBtn1 hover:text-amber-400'
            >
              {subheader.item}
            </Link>
          </div>
        ))}
      </div>
      <h1 className='text-black font-extrabold text-4xl py-10'>
        {(type ? type : 'popular').toUpperCase()}
      </h1>

      <div className='container mx-auto pt-10'>
        <div className='grid md:grid-cols-3 md:gap-4 gap-2 xl:grid-cols-6 grid-cols-2 '>
          {currentPost?.map((movie) => (
            <CardDetails movie={movie} />
          ))}
        </div>
      </div>

      <Pagination
        totalPosts={movie?.length}
        postsPerPage={postsPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
      />
    </div>
  );
};

export default AllMovieList;
